import { gql, useMutation } from '@apollo/client'
import useAuth from 'lib/auth/useAuth'

const SetMarketingOptIn = gql`
  mutation SetMarketingOptIn($marketingOptInAt: ISO8601DateTime) {
    setMarketingOptIn(marketingOptInAt: $marketingOptInAt) {
      success
      message
    }
  }
`

const isUnauthorizedError = error =>
  error?.graphQLErrors?.some(
    ({ extensions }) => extensions?.code === 'UNAUTHORIZED',
  ) ||
  error?.networkError?.statusCode === 401 ||
  error?.message?.includes('Unauthorized')

export const useSetMarketingOptIn = () => {
  const { isLoggedIn } = useAuth()
  const [setMarketingOptInMutation, { data, loading, error }] = useMutation(
    SetMarketingOptIn,
  )

  const setMarketingOptIn = marketingOptInChecked => {
    if (!isLoggedIn) {
      return
    }

    const marketingOptInAt = marketingOptInChecked
      ? (() => {
        const date = new Date()
        date.setSeconds(0, 0)
        return date.toISOString()
      })()
      : null

    return setMarketingOptInMutation({
      variables: { marketingOptInAt },
    }).catch(mutationError => {
      if (!isUnauthorizedError(mutationError)) {
        return Promise.reject(mutationError)
      }
    })
  }

  return { setMarketingOptIn, data, loading, error }
}
